import React from 'react';

import {H2} from '@pb/kit-component-typography';

import {
    placeholderContainer,
    placeholderIcon,
    placeholderText,
} from './placeholder.styles.module.styl';

type PlaceholderViewProps = {
    title: string;
    icon?: string;
};

const PlaceholderView: React.FC<PlaceholderViewProps> = ({title, icon = '🚧'}) => (
    <div className={placeholderContainer}>
        <div className={placeholderIcon}>{icon}</div>
        <H2>{title}</H2>
        <p className={placeholderText}>This module is under development.</p>
    </div>
);

export const CompanyManagementView: React.FC = () => <PlaceholderView title="Company Management" icon="🏢"/>;
export const RnaMappingView: React.FC = () => <PlaceholderView title="RNA Mapping" icon="🔗"/>;
export const CompanyListView: React.FC = () => <PlaceholderView title="Company List" icon="📋"/>;
export const PushCompaniesView: React.FC = () => <PlaceholderView title="Push Companies" icon="📤"/>;
export const ManageEventCalendarView: React.FC = () => <PlaceholderView title="Manage Event Calendar" icon="🗓️"/>;
